import React from 'react';
import { CheckIcon } from 'lucide-react';
const legalData = [{
  label: 'Entidad Legal',
  value: 'Massive Faith LLC'
}, {
  label: 'EIN',
  value: '39-5048643'
}, {
  label: 'Estado de Registro',
  value: 'Wyoming (WY)'
}, {
  label: 'Dirección de Oficina Principal',
  value: '1057 NW 136th Ave, Miami, FL 33182'
}, {
  label: 'Agente Registrado',
  value: 'Registered Agents Inc — 30 N Gould St, Suite R, Sheridan, WY 82801'
}, {
  label: 'Miembros',
  value: 'Alejo Lautaro Martinez Avellaneda (50%) · Tomas Ivan Martinez Avellaneda (50%)'
}, {
  label: 'Fecha de Constitución',
  value: '23 de octubre de 2025'
}, {
  label: 'Email de Contacto',
  value: 'info@massivefaith.site'
}];
const operations = [{
  title: 'Venta online:',
  description: 'los productos digitales se comercializan directamente en nuestras tiendas online (Shopify): citasdiferentes.store y nightdate.store.'
}, {
  title: 'Entrega digital:',
  description: 'la entrega es 100% online. Los clientes reciben acceso al producto de forma inmediata tras la compra (email y/o descarga directa).'
}, {
  title: 'Operación remota:',
  description: 'la empresa opera de forma 100% remota. No posee local físico ni empleados en relación de dependencia.'
}];
export function App() {
  return <div className="min-h-screen bg-slate-50 text-slate-900 font-sans py-10 px-5" data-id="element-0">
      <div className="max-w-[1080px] mx-auto" data-id="element-1">
        {/* Header */}
        <header className="mb-12" data-id="element-2">
          <div className="inline-flex items-center bg-white border border-slate-200 text-slate-600 px-3.5 py-1.5 rounded-full text-sm font-medium mb-6 shadow-sm" data-id="element-3">
            <span className="w-2 h-2 bg-emerald-500 rounded-full mr-2" data-id="element-4"></span>
            Página Institucional
          </div>
          <h1 className="text-4xl md:text-[2.5rem] font-bold text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-5">
            Massive Faith LLC
          </h1>
          <p className="text-lg text-slate-600 max-w-[780px] mb-10" data-id="element-6">
            Empresa dedicada a la venta de productos digitales, juegos de
            investigación online para parejas que se entregan a traves de email
            y/o descarga directa
          </p>
        </header>

        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_0.8fr] gap-10 md:gap-12 items-start" data-id="element-7">
          {/* Column 1: Who we are + CTAs */}
          <section data-id="element-8">
            <h2 className="text-xl font-semibold mb-5" data-id="element-9">Quiénes somos</h2>
            <div className="text-slate-600 space-y-4" data-id="element-10">
              <p data-id="element-11">
                Massive Faith LLC es una empresa registrada en Wyoming que crea
                y comercializa productos digitales descargables (juegos de
                investigación, experiencias interactivas y recursos de
                entretenimiento) vendidos a través de tiendas online (Shopify).
              </p>

              <div className="flex flex-wrap gap-4 mt-6" data-id="element-12">
                <a href="https://citasdiferentes.store/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3.5 rounded-lg font-medium text-[0.95rem] bg-white text-slate-900 border border-slate-200 hover:border-slate-600 hover:bg-slate-100 transition-all min-w-[180px]" data-id="element-13">
                  Ver Productos Digitales
                </a>
                <a href="https://citasdiferentes.store/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3.5 rounded-lg font-medium text-[0.95rem] bg-gray-900 text-white border border-gray-900 hover:bg-gray-800 transition-all min-w-[180px]" data-id="element-14">
                  Visitar Tienda
                </a>
              </div>
            </div>
          </section>

          {/* Column 2: Legal Data */}
          <aside data-id="element-15">
            <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-16">
              {legalData.map((item, index) => <div key={index} className={`flex flex-col px-6 py-4 ${index !== legalData.length - 1 ? 'border-b border-slate-200' : ''}`} data-id="element-17">
                  <span className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-1" data-id="element-18">
                    {item.label}
                  </span>
                  <span className="text-[0.95rem] font-medium text-slate-900 break-words" data-id="element-19">
                    {item.value}
                  </span>
                </div>)}
            </div>
          </aside>
        </div>

        <div className="my-16 border-t border-slate-200" data-id="element-20"></div>

        {/* Operations Section */}
        <section data-id="element-21">
          <h2 className="text-xl font-semibold text-center mb-8" data-id="element-22">
            Cómo operamos
          </h2>
          <div className="bg-white border border-slate-200 rounded-2xl p-8 max-w-[800px] mx-auto space-y-4" data-id="element-23">
            {operations.map((op, index) => <div key={index} className="flex items-start text-[0.95rem] text-slate-600" data-id="element-24">
                <CheckIcon className="w-5 h-5 text-emerald-500 mr-4 flex-shrink-0 mt-0.5 stroke-[3]" data-id="element-25" />
                <div data-id="element-26">
                  <strong className="text-slate-900 font-semibold" data-id="element-27">
                    {op.title}
                  </strong>{' '}
                  {op.description}
                </div>
              </div>)}
          </div>
        </section>

        {/* Contact Section */}
        <section className="text-center bg-slate-100 p-10 rounded-2xl mt-16" data-id="element-28">
          <h3 className="text-lg font-semibold mb-3" data-id="element-29">Contacto</h3>
          <p className="text-slate-600 mb-4" data-id="element-30">
            ¿Tenés alguna duda? Escribinos directamente.
          </p>
          <a href="mailto:martinezavellanedaa@gmail.com" className="text-[1.1rem] font-semibold text-slate-900 border-b border-slate-200 pb-0.5 hover:border-slate-900 transition-colors inline-block" data-id="element-31">
            info@massivefaith.site
          </a>
        </section>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-slate-200 text-center text-sm text-slate-400" data-id="element-32">
          <nav className="mb-4 flex justify-center flex-wrap gap-x-6 gap-y-2" data-id="element-33">
            <a href="#" className="text-slate-600 font-medium hover:text-slate-900 transition-colors" data-id="element-34">
              Política de Privacidad
            </a>
            <a href="#" className="text-slate-600 font-medium hover:text-slate-900 transition-colors" data-id="element-35">
              Términos de Servicio
            </a>
            <a href="#" className="text-slate-600 font-medium hover:text-slate-900 transition-colors" data-id="element-36">
              Política de Reembolso
            </a>
          </nav>
          <p data-id="element-37">© 2025 Massive Faith LLC. Todos los derechos reservados.</p>
        </footer>
      </div>
    </div>;
}